// Dashboard services
import AgentService from "./agent.service";
import AiAssistantService from "./aiAssistant.service";
import TicketService from "./ticket.service";
import AnswerRuleService from "./answerRule.service";
import PersonaService from "./persona.service";

export default {
  AgentService,
  AiAssistantService,
  TicketService,
  AnswerRuleService,
  PersonaService,
};
